import { useFonts } from "wallet-elementkit/dist/hooks";
import React from "react";
import translations from "../../translations/verify.json";
import claimFlowTranslations from "../../translations/claimFlow.json";
import "pure-react-carousel/dist/react-carousel.es.css";

import {
	DetailType,
	DetailCost,
	DetailDuration,
	DetailDurationType,
	DetailLevel,
} from "wallet-elementkit/dist/translations";

import { generateAdLog } from "../../services/verifiedBackendService/AdLog";
import {
	searchCredential,
	getPreviewWithDeliveryId,
} from "../../services/verifiedBackendService/search";
import { handleShareAnon } from "../../services/verifiedBackendService/event";

import { AdEventTypes, EventActions } from "../../constants/Enums";
import { storeItem, getItem } from "../../backend/StorageUtils";
import { dummyCredentialData } from "../../backend/constants";
import "../../styles/verify/web.scss";
import "../../styles/verify/mobile.scss";
import "../../styles/verify/newVerify.scss";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import NotFound from "../../components/common/NotFound";
import { withLocalize } from "react-localize-redux";
import {
	EvidenceBackend,
	OptimizedMixPanel,
	UserUtils,
} from "wallet-elementkit/dist/services";
import mixpanel from "mixpanel-browser";
import {
	DetailCost as DetailCostEnum,
	DetailLevel as DetailLevelEnum,
} from "wallet-elementkit/dist/constants/constants";
import LinkedinSharePopUp from "../../components/verify/LinkedinSharePopUp";
import { logActionEvent } from "wallet-elementkit/dist/services/backend/Events";
const NewVerifyWeb = React.lazy(() => import("./NewVerifyWeb"));
const NewVerifyMobile = React.lazy(() => import("./NewVerifyMobile"));

function NewVerify(props) {
	const detailDuration = DetailDuration;
	const detailLevel = DetailLevel;
	const detailDurationType = DetailDurationType;
	const detailTypes = DetailType;
	const detailCost = DetailCost;
	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);
	const [issued_by, setIssuedBy] = useState(null);
	const [url, setUrl] = useState("");
	const [badgeUrl, setBadgeUrl] = useState("");
	const [searchCredentialResp, setSearchCredentialResp] = useState();
	const [fonts, setFonts] = useState([]);
	const [credno, setCredno] = useState(window.location.pathname.split("/")[3]);
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [type, setType] = useState("");
	const [level, setLevel] = useState("");
	const [skills, setSkills] = useState([]);
	const [duration, setDuration] = useState("");
	const [cost, setCost] = useState("");
	const [createDate, setCreateDate] = useState("");
	const [expireDate, setExpireDate] = useState("");
	const [userName, setUserName] = useState("");
	const [userEmail, setUserEmail] = useState("");
	const [courseRatingCount, setCourseRatingCount] = useState(0);
	const [courseRating, setCourseRating] = useState(0.0);
	const [attendeeCount, setAttendeeCount] = useState(0);
	const [earningCriteriaHTML, setEarningCriteriaHTML] = useState("");
	const [detailName, setDetailName] = useState("");
	const [issuerEmail, setIssuerEmail] = useState("");
	const [userFullName, setUserFullName] = useState("");
	const [userPhoto, setUserPhoto] = useState("");
	const [details, setDetails] = useState({});
	const [canvasWait, setCanvasWait] = useState(false);
	const [consumedContents, setConsumedContents] = useState([]);
	const [createDatePlain, setCreateDatePlain] = useState("");
	const [expireDatePlain, setExpireDatePlain] = useState("");
	const [isBlockchainSecured, setIsBlockchainSecured] = useState(false);
	const [credentialName, setCredentialName] = useState("");
	const [imageLoading, setImageLoading] = useState(false);
	const [collection, setCollection] = useState({});
	const [linkedinOrgNo, setLinkedinOrgNo] = useState(null);
	const [adDetails, setAdDetails] = useState(null);
	const [adLink, setAdLink] = useState({});
	const [redirectSuccessful, setRedirectSuccessful] = useState(false);
	const [linkedinAccessToken, setLinkedinAccessToken] = useState("");
	const [linkedinUserId, setLinkedinUserId] = useState("");
	const [velocityOffer, setVelocityOffer] = useState(null);
	const [isCustomization, setIsCustomization] = useState(false);
	const [evidences, setEvidences] = useState([]);
	const [isEvidencesLoading, setIsEvidencesLoading] = useState(true);
	const [isScrollLocked, setIsScrollLocked] = useState(false);
	const [design, setDesign] = useState({});
	const [badgeDesign, setBadgeDesign] = useState({});
	const [isExpired, setIsExpired] = useState(false);
	const [
		supportingDocumentationsWithMeta,
		setSupportingDocumentationsWithMeta,
	] = useState([]);
	const [isLoggedInUser, setIsLoggedInUser] = useState(false);
	const [organizationId, setOrganizationId] = useState("");
	const [recipientGroupId, setRecipientGroupId] = useState("");
	const [isClaimedProfile, setIsClaimedProfile] = useState(false);

	const userMeta = useAppSelector(selectUser);
	const location = useLocation();
	const [dialogOpen, setDialogOpen] = useState(
		(location.state?.fromVerification &&
			location.state?.actionType === "linkedinShare") ||
			false
	);

	const handleClickOpen = () => {
		setDialogOpen(true);
	};
	const handleClose = () => {
		setDialogOpen(false);
		setLinkedinAccessToken("");
	};

	useEffect(() => {
		optimizeDetailsForLanguage();
	}, [props.activeLanguage, searchCredentialResp]);

	async function fetchSupportingDocumentationLinks(certificationNo) {
		const supportingDocumentationLinks =
			await EvidenceBackend.parseSupportingDocumentationLinks(
				certificationNo || credno
			);

		setSupportingDocumentationsWithMeta(supportingDocumentationLinks);
	}

	useFonts(fonts);

	useEffect(() => {
		const search = location.search;
		const canvas = new URLSearchParams(search).get("canvas") === "true";
		const isCustomization =
			new URLSearchParams(search).get("customization") === "true";
		setIsCustomization(isCustomization);
		const linkedinAuthCode = new URLSearchParams(search).get("code");
		if (linkedinAuthCode) {
			setLinkedinAccessToken(linkedinAuthCode);
		}
		if (canvas) {
			// Handle loop for canvas until credential is created
			setCanvasWait(true);
			let reqCount = 100; // Max number of requests
			let searchRes;
			let intervalId = setInterval(async () => {
				if (reqCount === 0 || searchRes) clearInterval(intervalId);
				await handleSearch({
					canvas: true,
				})
					.then((res) => (searchRes = true))
					.catch((e) => (searchRes = false));
				reqCount--;
			}, 4000);
		} else {
			// setParsedEvidences();
			(async function fetchSearchData() {
				await handleSearch({ isCustomization: isCustomization });
			})();
		}
		if (details.adContainer) createAdLog(AdEventTypes["view"]);
	}, [credno]);

	useEffect(() => {
		props.addTranslation(translations);
		props.addTranslation(claimFlowTranslations);
	}, []);

	useEffect(() => {
		setIsLoggedInUser(
			userName !== "" &&
				userMeta.user.username !== "" &&
				userName === userMeta.user.username
		);
	}, [userMeta]);

	const changeMonthToLocalName = (date) => {
		date = date.substring(0, date.indexOf("T"));
		let dateArr = date.split("-");
		let shortMonthDate = new Date();
		shortMonthDate.setMonth(dateArr[1] - 1);
		let shortMonthName = shortMonthDate.toLocaleDateString(
			props.activeLanguage ? props.activeLanguage.code : "en-us",
			{ month: "short" }
		);
		dateArr[1] = shortMonthName;
		return dateArr.join("-");
	};

	function optimizeDetailsForLanguage() {
		if (searchCredentialResp && props.activeLanguage) {
			let resp = searchCredentialResp;
			setIsBlockchainSecured(resp.isBlockchainSecured);
			setVelocityOffer(resp.velocityOffer);
			setCredentialName(resp.result.name);
			setDetailName(resp.details.detail.title);
			setUrl(resp.result.url || "");
			setBadgeUrl(resp.result.badgeUrl || "");
			setIssuedBy(resp.result.issued_by);
			setUserName(resp.result.userName);
			setUserEmail(resp.result.userEmail);
			setUserPhoto(resp.result.userPhoto);
			setIsClaimedProfile(resp.result.isClaimedProfile);
			setUserFullName(resp.result.userFullName);
			setDetails(resp.details);
			setType(
				detailTypes[props.activeLanguage?.code || "en"][
					resp.details.detail.type
				]
			);
			setLevel(
				resp.details.detail.level === DetailLevelEnum.NA
					? ""
					: detailLevel[props.activeLanguage?.code || "en"][
							resp.details.detail.level
					  ]
			);
			setDuration(
				resp.details.detail.duration === 5
					? ""
					: resp.details.detail.duration === 4
					? `${resp.details.detail.durationNumber} ${
							resp.details.detail.durationNumber > 1 &&
							props.activeLanguage?.code === "en"
								? detailDurationType[props.activeLanguage?.code || "en"][
										resp.details.detail.durationType - 1
								  ] + "s"
								: detailDurationType[props.activeLanguage?.code || "en"][
										resp.details.detail.durationType - 1
								  ]
					  }`
					: detailDuration[props.activeLanguage?.code || "en"][
							resp.details.detail.duration
					  ]
			);
			setCost(
				resp.details.detail.cost === DetailCostEnum.NA
					? ""
					: detailCost[props.activeLanguage?.code || "en"][
							resp.details.detail.cost
					  ]
			);
			setCreateDate(
				changeMonthToLocalName(
					resp.details.issueDate || resp.details.detail.createDate || ""
				)
			);
			setCreateDatePlain(
				resp.details.issueDate || resp.details.detail.createDate || ""
			);
			setExpireDate(
				resp.details.detail.expireDate
					? changeMonthToLocalName(resp.details.detail.expireDate)
					: ""
			);
			setExpireDatePlain(resp.details.detail.expireDate || "");
			setCourseRating(
				resp.details.detail.courseRating
					? resp.details.detail.courseRating
					: 0.0
			);
			setCourseRatingCount(
				resp.details.detail.courseRatingCount
					? resp.details.detail.courseRatingCount
					: 0
			);
			setAttendeeCount(
				resp.details.detail.attendeeCount
					? resp.details.detail.attendeeCount
					: 0
			);
			setEarningCriteriaHTML(resp.details.detail.earningCriteriaHTML || "");
			setConsumedContents(
				resp.details.isFurtherCollection ? resp.consumedContents : []
			);
			setFonts(resp.details.fonts ?? []);
			setIsLoggedInUser(
				resp.result.userName !== "" &&
					userMeta.user.username !== "" &&
					resp.result.userName === userMeta.user.username
			);
		}
	}
	const handleSearch = async (
		options = { canvas: false, isCustomization: false }
	) => {
		let resp;
		let viewerId = getItem("__uid__");
		if (!viewerId) {
			viewerId = UserUtils.genereateViewerId();
			storeItem("__uid__", viewerId);
		}
		const queries = new URLSearchParams(props.location.search);
		const referrerUrl = document.referrer
			? document.referrer
			: queries.get("ref");
		if (props.isPreview) {
			const certNo = queries.get("certNo");
			const search = location.search;
			const lockScroll =
				new URLSearchParams(search).get("lockScroll") === "true";
			const [searchResult, supportingDocs] = await Promise.all([
				getPreviewWithDeliveryId(
					props.deliveryId,
					window.location.pathname.split("/")[1],
					window.location.href,
					certNo
				),
				fetchSupportingDocumentationLinks(certNo),
			]);
			resp = searchResult;
			setIsScrollLocked(lockScroll);
		} else {
			if (options.isCustomization) {
				resp = dummyCredentialData;
			} else {
				const [searchResult, supportingDocs] = await Promise.all([
					searchCredential(
						credno,
						window.location.pathname.split("/")[1],
						window.location.href,
						referrerUrl || window.location.href,
						viewerId
					),
					fetchSupportingDocumentationLinks(),
				]);
				resp = searchResult;
			}
		}
		if (!resp.success) {
			if (options.canvas) {
				return false;
			}
			if (resp.isDeleted) {
				setErrorMessage("deleted");
				setIsLoading(false);
				setIssuerEmail(resp.organization.email);
			} else {
				setErrorMessage("notFound");
				setIsLoading(false);
			}
			setSearchCredentialResp(undefined);
			return;
		}
		if (!resp.details.organization.logoLink) {
			resp.details.organization.logoLink =
				require("../../assets/fallbacks/organization.svg").default;
		}
		if (resp.details.collection) {
			resp.details.collection.deliveries =
				resp.details.collection.deliveries.length > 3
					? resp.details.collection.deliveries.slice(0, 3)
					: resp.details.collection.deliveries;
		}
		setUrl(resp.result.url || "");
		setCredentialName(resp.result.name);
		setIsBlockchainSecured(resp.isBlockchainSecured);
		setVelocityOffer(resp.velocityOffer);
		setBadgeUrl(resp.result.badgeUrl || "");
		setBadgeDesign(resp.details.badgeDesign || null);
		setDesign(resp.details.certificateDesign || null);
		setIssuedBy(resp.result.issued_by);
		setUserName(resp.result.userName);
		setUserEmail(resp.result.userEmail);
		setUserFullName(resp.result.userFullName);
		setUserPhoto(resp.result.userPhoto);
		setIsClaimedProfile(resp.result.isClaimedProfile);
		setType(DetailType[props.activeLanguage.code][resp.details.detail.type]);
		setCreateDatePlain(
			resp.details.issueDate || resp.details.detail.createDate
		);
		setExpireDatePlain(resp.details.detail.expireDate || "");
		setLevel(
			resp.details.detail.level === DetailLevelEnum.NA
				? null
				: DetailLevel[props.activeLanguage.code][resp.details.detail.level]
		);
		setDetails(resp.details);
		setSkills(resp.details.skills);
		setDuration(
			resp.details.detail.duration === 5
				? null
				: resp.details.detail.duration === 4
				? `${resp.details.detail.durationNumber} ${
						resp.details.detail.durationNumber > 1 &&
						props.activeLanguage.code === "en"
							? DetailDurationType[props.activeLanguage.code][
									resp.details.detail.durationType - 1
							  ] + "s"
							: DetailDurationType[props.activeLanguage.code][
									resp.details.detail.durationType - 1
							  ]
				  }`
				: DetailDuration[props.activeLanguage.code][
						resp.details.detail.duration
				  ]
		);
		setCost(
			resp.details.detail.cost === DetailCostEnum.NA
				? null
				: DetailCost[props.activeLanguage.code][resp.details.detail.cost]
		);
		setCreateDate(
			changeMonthToLocalName(
				resp.details.issueDate || resp.details.detail.createDate || ""
			)
		);
		setExpireDate(
			resp.details.detail.expireDate
				? changeMonthToLocalName(resp.details.detail.expireDate)
				: ""
		);
		setCourseRating(
			resp.details.detail.courseRating ? resp.details.detail.courseRating : 0.0
		);
		setCourseRatingCount(
			resp.details.detail.courseRatingCount
				? resp.details.detail.courseRatingCount
				: 0
		);
		setAttendeeCount(
			resp.details.detail.attendeeCount ? resp.details.detail.attendeeCount : 0
		);
		setEarningCriteriaHTML(resp.details.detail.earningCriteriaHTML || "");
		setIsLoading(false);
		setCanvasWait(false);
		setConsumedContents(
			resp.details.isFurtherCollection ? resp.consumedContents : []
		);
		setCollection(resp.details.collection);
		setLinkedinOrgNo(resp.details.organization.linkedinOrganizationNo);
		setAdDetails(resp.details.adContainer);
		setAdLink(
			resp.details.adContainer ? resp.details.adContainer.adLinks[0] : {}
		);
		setIsLoggedInUser(
			resp.result.userName !== "" &&
				userMeta.user.username !== "" &&
				resp.result.userName === userMeta.user.username
		);
		setFonts(resp.details.fonts ?? []);
		setIsExpired(resp.details.isExpired);
		setOrganizationId(resp.details.organization.id);
		setRecipientGroupId(resp.details.recipientGroupId);
		setSearchCredentialResp(resp);
		optimizedMixpanel.track("Credential View", {
			credential_no: credno,
			ownership:
				resp.result.userName !== "" &&
				userMeta.user.username !== "" &&
				resp.result.userName === userMeta.user.username,
			isLogged: userMeta.logged,
			isIssuerBadge: resp.details.isIssuerBadge,
		});
	};

	const handleUncreatedImage = async () => {
		setImageLoading(true);
		setTimeout(() => {
			setImageLoading(false);
		}, 10000);
	};

	useEffect(() => {
		if (linkedinAccessToken && !dialogOpen) {
			handleClickOpen();
		}
	}, [linkedinAccessToken, dialogOpen, credno]);

	async function handleActionEvent(action) {
		await logActionEvent(
			credno,
			EventActions[action],
			organizationId,
			recipientGroupId
		);
	}

	const handleMailTo = async (type) => {
		if (props.activeLanguage) {
			if (type === "reportNotFound")
				if (props.activeLanguage.code === "en")
					window.open(
						`mailto:${process.env.REACT_APP_BASE_MAIL_TO}?subject=Certificate Not Found Issue with id ${credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
				else
					window.open(
						`mailto:${process.env.REACT_APP_BASE_MAIL_TO}?subject=Sertifika Bulunamadı Sorunu sertifika numarası: ${credno}&body=Merhaba, %0D%0A%0D%0A${credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
			if (type === "deletedCertificate")
				if (props.activeLanguage.code === "tr")
					window.open(
						`mailto:${issuerEmail}?subject=Silinmiş Sertifika, Sertifika numarası: ${credno}&body=Merhaba, %0D%0A%0D%0A${credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
				else
					window.open(
						`mailto:${issuerEmail}?subject=Deleted Certificate with id: ${credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
		}
	};

	const addLinkedin = () => {
		let issueYear = createDatePlain.split("-")[0];
		let issueMonth = createDatePlain.split("-")[1];
		let expirationMonth,
			expirationYear = "";
		if (expireDate) {
			expirationYear = expireDatePlain.split("-")[0];
			expirationMonth = expireDatePlain.split("-")[1];
		}

		var win = window.open(
			`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(
				detailName
			)}&organizationName=${encodeURIComponent(
				issued_by
			)}&issueYear=${issueYear}&issueMonth=${issueMonth}&certId=${credno}&certUrl=${
				window.location.href.split("?")[0]
			}&expirationYear=${expirationYear || ""}&expirationMonth=${
				expirationMonth || ""
			}
			${linkedinOrgNo ? "&organizationId=" + linkedinOrgNo : ""}`
		);
		if (win == null) {
			setRedirectSuccessful(false);
		} else {
			setRedirectSuccessful(true);
			handleShareAnon("setlinkedinprofile", credno, organizationId);
			optimizedMixpanel.track("Linkedin Add to Profile", {
				credential_no: credno,
				ownership: isLoggedInUser,
				isLogged: userMeta.logged,
			});
			win.focus();
		}
	};

	const createAdLog = (eventType) => {
		let viewer = getItem("__adslg__");
		let viewerId;
		if (!viewer) {
			viewerId = UserUtils.genereateViewerId();
			storeItem("__adslg__", { id: viewerId });
		} else {
			viewerId = viewer.id;
		}
		let referrerUrl;
		let queries = new URLSearchParams(location.search);
		referrerUrl = document.referrer ? document.referrer : queries.get("ref");
		generateAdLog(
			viewerId,
			eventType,
			referrerUrl || window.location.href,
			adDetails.deliveryId,
			credno,
			adLink.id
		);
	};

	if (!errorMessage) {
		if (props.isMobile) {
			return (
				<div id="verify-container-mobile">
					<NewVerifyMobile
						velocityOffer={velocityOffer}
						isBlockchainSecured={isBlockchainSecured}
						isClaimedProfile={isClaimedProfile}
						loading={isLoading}
						canvasWait={canvasWait}
						isScrollLocked={isScrollLocked}
						imageLoading={imageLoading}
						isPreview={props.isPreview}
						credentialName={credentialName}
						url={url}
						triggerCanShareNow={
							location.state?.fromVerification &&
							location.state?.actionType === "linkedinShare"
						}
						triggerCanRequestNow={
							location.state?.fromVerification &&
							location.state?.actionType === "nameChangeRequest"
						}
						issuerEmail={issuerEmail}
						userPhoto={userPhoto}
						skills={skills}
						badgeUrl={badgeUrl}
						issued_by={issued_by}
						userName={userName}
						userEmail={userEmail}
						userFullName={userFullName}
						type={type}
						level={level}
						duration={duration}
						cost={cost}
						createDate={createDate}
						credNo={credno}
						attendeeCount={attendeeCount}
						earningCriteriaHTML={earningCriteriaHTML}
						courseRating={courseRating}
						courseRatingCount={courseRatingCount}
						expireDate={expireDate}
						expireDatePlain={expireDatePlain}
						evidences={evidences}
						consumedContents={consumedContents}
						credentialDetails={details}
						redirectSuccessful={redirectSuccessful}
						isLoggedInUser={isLoggedInUser}
						logged={userMeta.logged}
						addLinkedin={addLinkedin}
						handleUncreatedImage={handleUncreatedImage}
						createAdLog={createAdLog}
						translate={props.translate}
						handleClickOpen={handleClickOpen}
						activeLanguage={props.activeLanguage}
						addTranslation={props.addTranslation}
						isCustomization={isCustomization}
						supportingDocumentationsWithMeta={supportingDocumentationsWithMeta}
						{...props}
					/>
					{!isLoading && dialogOpen ? (
						<LinkedinSharePopUp
							dialogOpen={dialogOpen}
							handleClose={handleClose}
							translate={props.translate}
							handleUncreatedImage={handleUncreatedImage}
							userFullName={userFullName}
							triggerCanShareNow={
								location.state?.fromVerification &&
								location.state?.actionType === "linkedinShare"
							}
							skipAuthForIssuerBadge={details.isIssuerBadge}
							userEmail={userEmail}
							addLinkedin={addLinkedin}
							setLinkedinToken={(newToken) => {
								setLinkedinAccessToken(newToken);
							}}
							setLinkedinUserId={(newId) => {
								setLinkedinUserId(newId);
							}}
							openDialog={handleClickOpen}
							issued_by={issued_by}
							credential_name={
								isLoading ? credentialName : details.detail.title
							}
							skills={details.skills}
							articleUrl={window.location.href.toString().split("?")[0]}
							tokenCode={linkedinAccessToken}
							addTranslation={props.addTranslation}
							userId={linkedinUserId}
							credential_no={credno}
							organization_id={details.organization.id}
							redirectSuccessful={redirectSuccessful}
							certificate_url={url}
							badge_url={badgeUrl}
							isLoggedInUser={isLoggedInUser}
							logged={userMeta.logged}
							userName={userName}
							activeLanguage={props.activeLanguage}
							shareText={details.socialSharingText}
						/>
					) : null}
				</div>
			);
		} else {
			return (
				<div id="verify-container-web">
					<NewVerifyWeb
						velocityOffer={velocityOffer}
						isBlockchainSecured={isBlockchainSecured}
						isClaimedProfile={isClaimedProfile}
						loading={isLoading}
						canvasWait={canvasWait}
						isScrollLocked={isScrollLocked}
						imageLoading={imageLoading}
						isPreview={props.isPreview}
						credentialName={credentialName}
						url={url}
						handleClickOpen={handleClickOpen}
						triggerCanShareNow={
							location.state?.fromVerification &&
							location.state?.actionType === "linkedinShare"
						}
						triggerCanRequestNow={
							location.state?.fromVerification &&
							location.state?.actionType === "nameChangeRequest"
						}
						issuerEmail={issuerEmail}
						userPhoto={userPhoto}
						skills={skills}
						badgeUrl={badgeUrl}
						issued_by={issued_by}
						userName={userName}
						userEmail={userEmail}
						userFullName={userFullName}
						type={type}
						level={level}
						duration={duration}
						cost={cost}
						createDate={createDate}
						credNo={credno}
						attendeeCount={attendeeCount}
						earningCriteriaHTML={earningCriteriaHTML}
						courseRating={courseRating}
						courseRatingCount={courseRatingCount}
						expireDate={expireDate}
						expireDatePlain={expireDatePlain}
						evidences={evidences}
						consumedContents={consumedContents}
						credentialDetails={details}
						redirectSuccessful={redirectSuccessful}
						isLoggedInUser={isLoggedInUser}
						logged={userMeta.logged}
						addLinkedin={addLinkedin}
						handleUncreatedImage={handleUncreatedImage}
						createAdLog={createAdLog}
						isCustomization={isCustomization}
						supportingDocumentationsWithMeta={supportingDocumentationsWithMeta}
						{...props}
					/>
					{!isLoading && dialogOpen ? (
						<LinkedinSharePopUp
							dialogOpen={dialogOpen}
							handleClose={handleClose}
							translate={props.translate}
							skipAuthForIssuerBadge={details.isIssuerBadge}
							handleUncreatedImage={handleUncreatedImage}
							userFullName={userFullName}
							triggerCanShareNow={
								location.state?.fromVerification &&
								location.state?.actionType === "linkedinShare"
							}
							userEmail={userEmail}
							addLinkedin={addLinkedin}
							setLinkedinToken={(newToken) => {
								setLinkedinAccessToken(newToken);
							}}
							setLinkedinUserId={(newId) => {
								setLinkedinUserId(newId);
							}}
							openDialog={handleClickOpen}
							issued_by={issued_by}
							credential_name={
								isLoading ? credentialName : details.detail.title
							}
							skills={details.skills}
							articleUrl={window.location.href.toString().split("?")[0]}
							tokenCode={linkedinAccessToken}
							addTranslation={props.addTranslation}
							userId={linkedinUserId}
							credential_no={credno}
							organization_id={details.organization.id}
							redirectSuccessful={redirectSuccessful}
							certificate_url={url}
							badge_url={badgeUrl}
							isLoggedInUser={isLoggedInUser}
							logged={userMeta.logged}
							userName={userName}
							activeLanguage={props.activeLanguage}
							shareText={details.socialSharingText}
						/>
					) : null}
				</div>
			);
		}
	} else {
		return (
			<NotFound
				isMobile={props.isMobile}
				errorMessage={errorMessage}
				handleMailTo={handleMailTo}
			/>
		);
	}
}

export default withLocalize(NewVerify);
